import { ThemeEvents } from '@theme/events';

/**
 * Syncs fees display with the selected variant by listening to variant updates.
 */
class ProductFees extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    if (!this.closestSection) return;
    this.closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateFees);
  }

  disconnectedCallback() {
    if (!this.closestSection) return;
    this.closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateFees);
  }

  updateFees = (event) => {
    const currentProductId = this.dataset.productId;
    const currentBlockId = this.dataset.blockId;

    if (!currentBlockId) return;

    if (event.detail?.data?.newProduct?.id) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== currentProductId
    ) {
      return;
    }

    const newHtml = event.detail?.data?.html;
    if (!newHtml) return;

    const selector = `product-fees[data-block-id="${currentBlockId}"][data-product-id="${this.dataset.productId}"] [ref="feesContainer"]`;
    const newFees = newHtml.querySelector(selector);
    const currentFees = this.querySelector('[ref="feesContainer"]');

    if (!newFees || !currentFees) return;

    if (currentFees.innerHTML !== newFees.innerHTML) {
      currentFees.replaceWith(newFees);
    }
  };
}

if (!customElements.get('product-fees')) {
  customElements.define('product-fees', ProductFees);
}
